module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat-check-78f853b3e72c2882942487b19df88441.svg";